// extracted by mini-css-extract-plugin
export default {"assigneesList":"Assignees-module__assigneesList--JFnuE","assigneeNameLabel":"Assignees-module__assigneeNameLabel--f9fCg"};